import AIIcon from '@mdi/svg/svg/creation.svg?react';
import { IconWithTooltip, MDIIcon, useModal } from '@solinkcorp/solink-components';
import { setFilter } from 'actions/filterActions';
import classNames from 'classnames';
import SpotCheckPanel from 'components/SpotCheckPanel/SpotCheckPanel';
import { useLocation } from 'react-router-dom';
import useLocale from 'src/hooks/useLocale';
import { useDispatch, useSelector } from 'stores/store';
import { EVENTS_URL } from 'utils/urls';
import styles from './Sidekick.module.sass';

interface SidekickProps {
  // display new look with video search available, otherwise display old look
  isNewLook: boolean;
}

export default function Sidekick({ isNewLook }: SidekickProps) {
  const spotCheckPanelProps = useModal();
  const cameraSelectMode = useSelector((state) => state.filter.cameraSelectMode);
  const dispatch = useDispatch();
  const location = useLocation();
  const openEventSpotCheckMode = location.pathname.includes(EVENTS_URL);
  const isSpotCheckCameraSelectMode = cameraSelectMode === 'spot-check';
  const openModal = () => {
    spotCheckPanelProps.openModal();
    dispatch(
      setFilter({
        spotCheckMode: openEventSpotCheckMode ? 'event' : 'scheduled',
        cameraSelectMode: null,
      }),
    );
  };
  const locale = useLocale();
  return (
    <>
      {isNewLook ? (
        <IconWithTooltip
          className={classNames(styles.sidekick, {
            [styles.spotCheckCameraSelectMode]: isSpotCheckCameraSelectMode,
          })}
          title={locale.scheduledAIChat.spotCheck}
          icon={AIIcon}
          iconSize={18}
          onClick={openModal}
        />
      ) : (
        <button
          className={classNames(styles.sidekick, {
            [styles.spotCheckCameraSelectMode]: isSpotCheckCameraSelectMode,
            [styles.oldLook]: !isNewLook,
          })}
          onClick={openModal}
        >
          <MDIIcon icon={AIIcon} size={20} />
          <span>{locale.scheduledAIChat.sidekick}</span>
        </button>
      )}
      {spotCheckPanelProps.isModalOpen && (
        <SpotCheckPanel {...spotCheckPanelProps} isNewLook={isNewLook} />
      )}
    </>
  );
}
